import React from "react";
import InterventionListManager from "../../manager/intervention";

const InterventionPage = () => {
    return (
        <InterventionListManager/>
    )
}
export default InterventionPage;